var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { onError } from "@ane/core/lib/decorators/OnError";
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let FlightSearchResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.expmanVCurrent, "/flights");
  }
  searchFlights(address) {
    return __async(this, null, function* () {
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
};
__decorateClass([
  onError({ message: "Falied to fetch flights" })
], FlightSearchResources.prototype, "searchFlights", 1);
FlightSearchResources = __decorateClass([
  WPSProxyConverter()
], FlightSearchResources);
const FlightSearchResources$1 = new FlightSearchResources();
export {
  FlightSearchResources,
  FlightSearchResources$1 as default
};
//# sourceMappingURL=FlightSearchResources.js.map
